const HTTPStatusCodes = {
    SUCCESS: 200
}

export default HTTPStatusCodes